// src/App.tsx
import {useEffect} from "react";
import {Routes, Route, Navigate} from "react-router-dom";
import {initializeAuth} from "./store/slices/authSlice";
import {initializeUI} from "./store/slices/uiSlice";
import {store} from "./store";
import {AdminLayout} from "./components/common/Layout";
import ProtectedRoute from "./components/common/ProtectedRoute";
import ToastContainer from "./components/common/ToastContainer";
import ConfirmDialog from "./components/common/ConfirmDialog";

// Pages
import LoginPage from "./pages/Auth/LoginPage";
import ChangePasswordPage from "./pages/Auth/ChangePasswordPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import PropertiesPage from "./pages/Properties/PropertiesPage";
import PropertyCreatePage from "./pages/Properties/PropertyCreatePage";
import PropertyDetailPage from "./pages/Properties/PropertyDetailPage";
import {PropertyTypesPage, PropertyTypeCreatePage, PropertyTypeEditPage} from "./pages/PropertyTypes";
import PropertyEditPage from "./pages/Properties/PropertyEditPage";
import RegionsPage from "./pages/Regions/RegionsPage";
import TownshipsPage from "./pages/Townships/TownshipsPage";
import {UsersPage} from "./pages/Users";
import CustomersPage from "./pages/Customers/CustomersPage";
import AdminsPage from "./pages/Admins/AdminsPage";
import {ContactsPage} from "./pages/Contacts";
import {PropertyContactsPage} from "./pages/PropertyContacts";
import {ROUTES} from "./utils";
import {BannersPage} from "./pages/Banners";
import PrivacyPolicyPage from "./pages/PrivacyPolicy/PrivacyPolicyPage";

// Styles
// import "./styles/globals.css";

const App: React.FC = () => {
  useEffect(() => {
    // Initialize auth and UI state from localStorage
    store.dispatch(initializeAuth());
    store.dispatch(initializeUI());
  }, []);

  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

        {/* Protected admin routes */}
        <Route
          path="/*"
          element={
            <ProtectedRoute requireAdmin>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="dashboard" element={<DashboardPage />} />

          {/* Auth related */}
          <Route path="change-password" element={<ChangePasswordPage />} />

          {/* Properties */}
          <Route path="properties" element={<PropertiesPage />} />
          <Route path="properties/create" element={<PropertyCreatePage />} />
          <Route path="properties/:id" element={<PropertyDetailPage />} />
          <Route path="properties/:id/edit" element={<PropertyEditPage />} />

          {/* Property Types */}
          <Route path="property-types" element={<PropertyTypesPage />} />
          <Route path="property-types/create" element={<PropertyTypeCreatePage />} />
          <Route path="property-types/:id/edit" element={<PropertyTypeEditPage />} />

          {/* Locations */}
          <Route path="regions" element={<RegionsPage />} />
          <Route path="townships" element={<TownshipsPage />} />

          {/* Customer Management */}
          <Route path="customers" element={<CustomersPage />} />

          {/* Admin Management */}
          <Route path="admins" element={<AdminsPage />} />

          <Route path="banners" element={<BannersPage />} />

          {/* Communications */}
          {/* <Route path="inquiries" element={<InquiriesPage />} /> */}
          <Route path="contacts" element={<ContactsPage />} />
          <Route path="property-contacts" element={<PropertyContactsPage />} />

          {/* Settings */}
          {/* <Route path="price-ranges" element={<PriceRangesPage />} /> */}
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>

      <ToastContainer />
      <ConfirmDialog />
    </>
  );
};

export default App;
